import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-creator-banner _tc--lighter",
  "data-qa": "creator-banner"
}
const _hoisted_2 = { class: "_flex _jc-c _ai-c _h-full _w-100" }
const _hoisted_3 = { class: "gfu-layout__main gfu-layout__main--extranarrow _w-100 _pb-0" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "_px-2" }
const _hoisted_7 = {
  class: "gfu-hd gfu-hd--h1 _my-0 _tc--inverse",
  "data-qa": "creator-banner:title"
}
const _hoisted_8 = {
  key: 0,
  "data-qa": "creator-banner:location"
}
const _hoisted_9 = {
  class: "_mt-2 _pos-r",
  "data-qa": "creator-banner:description"
}
const _hoisted_10 = {
  key: 0,
  class: "_mt-2 _pos-r",
  "data-qa": "creator-banner-social-media"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_creator_banner_slider = _resolveComponent("creator-banner-slider")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_creator_banner_slider, { items: $props.bannerImages }, null, 8 /* PROPS */, ["items"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          draggable: "false",
          href: $props.urlName,
          class: "gfu-link gfu-link--nofx _flex _ai-c",
          "data-qa": "creator-banner:url"
        }, [
          _createElementVNode("img", {
            draggable: "false",
            class: "gfu-creator-banner__image",
            src: $props.creatorImageUrl,
            alt: $props.name,
            "data-qa": "creator-banner:creatorImage"
          }, null, 8 /* PROPS */, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", _hoisted_7, _toDisplayString($props.name), 1 /* TEXT */),
            ($props.displayedLocation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_base_icon, {
                    name: "map-marker",
                    class: "_mr-1"
                  }),
                  _createTextVNode(_toDisplayString($props.displayedLocation), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ], 8 /* PROPS */, _hoisted_4),
        _createElementVNode("div", _hoisted_9, _toDisplayString($props.description), 1 /* TEXT */),
        ($options.isSocialSectionVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.socialAccounts, (socialAccount) => {
                return (_openBlock(), _createBlock(_component_base_icon, {
                  key: socialAccount.type,
                  name: socialAccount.iconName,
                  "icon-namespace": socialAccount.iconNamespace,
                  class: _normalizeClass(socialAccount.class),
                  rel: socialAccount.rel,
                  draggable: socialAccount.draggable,
                  href: socialAccount.href,
                  tag: "a",
                  target: socialAccount.target,
                  "data-qa": socialAccount.dataQa
                }, null, 8 /* PROPS */, ["name", "icon-namespace", "class", "rel", "draggable", "href", "target", "data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}